import { render, staticRenderFns } from "./TopLocationMenuItemCard.vue?vue&type=template&id=316d017e&"
import script from "./TopLocationMenuItemCard.vue?vue&type=script&lang=js&"
export * from "./TopLocationMenuItemCard.vue?vue&type=script&lang=js&"
import style0 from "./TopLocationMenuItemCard.vue?vue&type=style&index=0&id=316d017e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports